import { FC, Fragment } from 'react';

type PatientReferralStatusFilterBoxType = {
    isLoading: boolean;
    label: string;
    onClick: () => void;
    isSelected: boolean;
    count?: number;
};
const PatientReferralStatusFilterBox: FC<PatientReferralStatusFilterBoxType> = ({
    isLoading,
    label,
    onClick,
    isSelected,
    count,
}) => {
    return (
        <div>
            <div
                className={`select-none px-16 py-8 space-y-4 border cursor-pointer rounded-4 text-13 min-w-160 ${
                    isSelected ? 'border-darwin-accent-bright-blue-800' : 'border-neutral-7'
                } ${isLoading ? 'pointer-events-none' : ''}`}
                onClick={onClick}
            >
                <p
                    className={`${
                        isSelected
                            ? 'font-700 text-darwin-accent-bright-blue-800'
                            : 'font-500 text-darwin-neutrals-600'
                    }`}
                >
                    {label}
                </p>
                <div className="flex items-baseline justify-between space-x-8">
                    {isLoading ? (
                        <div className="w-full h-32 shimmer"></div>
                    ) : !count ? (
                        <div className="w-full leading-7 text-18 min-h-32">-</div>
                    ) : (
                        <Fragment>
                            <Fragment>
                                {count && (
                                    <div className="flex items-end space-x-10">
                                        <p
                                            className={`text-21 font-700 ${
                                                isSelected
                                                    ? 'font-700 text-darwin-accent-bright-blue-800'
                                                    : 'font-500'
                                            }`}
                                        >
                                            {count}
                                        </p>
                                    </div>
                                )}
                            </Fragment>
                        </Fragment>
                    )}
                </div>
            </div>

            {isSelected && (
                <div className="w-16 h-16 flex items-center justify-center mx-auto">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320 512"
                        className="w-16 h-16 fill-darwin-accent-bright-blue-800"
                    >
                        <path d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z" />
                    </svg>
                </div>
            )}
        </div>
    );
};

const PatientReferralFilters: FC<{
    activeFilter: PatientReferralFilterType;
    isLoading: boolean;
    setFilter: (pf: PatientReferralFilterType) => void;
    filterData: FilterData;
}> = ({ isLoading, setFilter, activeFilter, filterData }): JSX.Element => {
    return (
        <div className="flex mt-8 space-x-16">
            {Object.entries(patientReferralFiltersObj).map(([key, value]) => {
                return (
                    <PatientReferralStatusFilterBox
                        label={value.label}
                        onClick={() => setFilter(key as PatientReferralFilterType)}
                        isSelected={activeFilter === key}
                        isLoading={isLoading}
                        count={filterData?.[key as PatientReferralFilterType]?.count}
                    />
                );
            })}
        </div>
    );
};

export default PatientReferralFilters;

export type FilterData = { [k in PatientReferralFilterType]: { count: number } };

export type PatientReferralFilterType = 'referrals-given' | 'referrals-received';

export const patientReferralFiltersObj: {
    [k in PatientReferralFilterType]: {
        id: PatientReferralFilterType;
        label: string;
    };
} = {
    'referrals-given': {
        id: 'referrals-given',
        label: 'Referrals given',
    },
    'referrals-received': {
        id: 'referrals-received',
        label: 'Referrals received',
    },
};
